function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from "vue";

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, [{
    key: "execute",
    value: function execute(spec, component) {
      if (!spec.views.length > 1) {
        console.warn("Make sure views only have 1 child!");
      }

      var target = component.updatables[spec.targetId];
      if (!target) console.error("no component found :" + spec.targetId);
      Object.assign(target.spec, spec.views[0]);
      this.updateComponent(target);
    }
  }, {
    key: "updateComponent",
    value: function updateComponent(component) {
      var _this = this;

      component.$ready();
      component.$forceUpdate(); // Execute on next tick to ensure that the child has received the updated spec.

      Vue.nextTick(function () {
        component.$children.find(function (child) {
          _this.updateComponent(child);
        });
      });
    }
  }]);

  return _default;
}();

export { _default as default };